export const getMexicoData = () => ({
  name: "Mexique",
  description: "Le Mexique est le berceau de la viticulture américaine, avec une histoire viticole qui remonte à l'arrivée des conquistadors espagnols. Le pays produit des vins de qualité dans des régions comme la Baja California, avec un climat méditerranéen unique.",
  type: "country",
  regions: [
    { name: "Baja California", area: "3,500 ha", percentage: "70%", description: "Cœur viticole" },
    { name: "Coahuila", area: "800 ha", percentage: "16%", description: "Vins de qualité" },
    { name: "Querétaro", area: "400 ha", percentage: "8%", description: "Vins d'altitude" },
    { name: "Autres", area: "300 ha", percentage: "6%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Baja California", x: -116.0, y: 32.0, color: "#4B164C", size: 5 },
    { region: "Coahuila", x: -101.0, y: 25.5, color: "#6d2c7a", size: 3 },
    { region: "Querétaro", x: -100.0, y: 20.5, color: "#8a4a8a", size: 2 }
  ],
  statistics: {
    totalArea: "5,000 ha",
    production: "0.3 million hectolitres",
    regions: "4 régions principales",
    appellations: "10+ appellations",
    exportPercentage: "10%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influences océaniques, étés chauds et secs",
    soil: "Sols granitiques, calcaires, argileux, excellente drainage",
    viticulture: "Viticulture moderne, irrigation contrôlée, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges fruités et accessibles, avec des tanins mûrs",
    white: "Vins blancs frais et aromatiques, avec une belle acidité",
    rosé: "Rosés fruités et accessibles, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture mexicaine remonte à l'arrivée des conquistadors espagnols au XVIe siècle. Les missionnaires ont introduit les premiers cépages. Le Mexique est le berceau de la viticulture américaine. Aujourd'hui, le Mexique produit des vins de qualité, principalement dans la Baja California.",
  foodPairing: "Cuisine mexicaine traditionnelle : tacos, enchiladas, mole, guacamole. Les vins mexicains s'accordent parfaitement avec la cuisine locale et les plats épicés."
}); 